import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40f76a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-size p-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Flows", -1))
const _hoisted_4 = { class: "nav toolbar my-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus fa-fw" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Add flow")
const _hoisted_7 = {
  key: 0,
  class: "active"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-diagram-project fa-2x" }, null, -1))
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.listVM.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: { name: 'automation-flows-add' },
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listVM.flows, (flow, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: { name: 'automation-flows-edit', params: { flowId: flow.id } },
              key: index,
              class: "flow",
              title: 'Flow ID: ' + flow.id
            }, {
              default: _withCtx(() => [
                (flow.active)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                  : _createCommentVNode("", true),
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(flow.name), 1)
              ]),
              _: 2
            }, 1032, ["to", "title"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_Spinner)
        ])),
    _createVNode(_component_router_view)
  ]))
}